import AmdrUploadModal from "./AmdrUploadModal";

export default AmdrUploadModal;
